var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from 'react';
import { MessageHeader } from './MessageHeader';
import classNames from 'classnames';
import { CloseButton } from './CloseButton';
import { MessageIcon } from './MessageIcon';
import { MessageCollapse } from './MessageCollapse';
import { Content } from './Content';
import { txt } from './texts';
export var ContextMessage = function (_a) {
    var type = _a.type, className = _a.className, onColoredBg = _a.onColoredBg, _b = _a.locale, locale = _b === void 0 ? 'nb' : _b, children = _a.children, onClose = _a.onClose, iconFileUrl = _a.iconFileUrl, header = _a.header, compact = _a.compact, closeButton = _a.closeButton, rest = __rest(_a, ["type", "className", "onColoredBg", "locale", "children", "onClose", "iconFileUrl", "header", "compact", "closeButton"]);
    var _c = useState(false), isClosed = _c[0], setIsClosed = _c[1];
    return (React.createElement(MessageCollapse, { isClosed: isClosed },
        React.createElement("div", __assign({ className: classNames("ffe-message", "ffe-message--context", "ffe-message--".concat(type), {
                'ffe-message--context-compact': compact,
                'ffe-message--colored-bg': onColoredBg,
            }, className), role: type === 'error' ? 'alert' : 'group', "aria-label": txt[locale][type].ariaLabel }, rest),
            React.createElement("div", { className: "ffe-message__background" },
                React.createElement(MessageIcon, { iconFileUrl: iconFileUrl }),
                React.createElement(Content, null,
                    typeof header === 'string' ? (React.createElement(MessageHeader, { as: "h2" }, header)) : (header),
                    children),
                closeButton && (React.createElement(CloseButton, { locale: locale, onClick: function () {
                        setIsClosed(true);
                        onClose === null || onClose === void 0 ? void 0 : onClose();
                    } }))))));
};
